import React from "react";
import { Paper, Stack, Typography, Box } from "@mui/material";

export default function StatCard({ icon, label, value, hint }) {
  return (
    <Paper
      sx={{
        p: { xs: 2.2, md: 2.6 },
        borderRadius: 1,
        height: "100%",
      }}
    >
      <Stack direction="row" spacing={1.6} alignItems="center">
        <Box
          sx={{
            width: 46,
            height: 46,
            borderRadius: 1,
            display: "grid",
            placeItems: "center",
            bgcolor: "rgba(37,99,235,0.10)",
            color: "primary.main",
            border: "1px solid rgba(11,18,32,0.08)",
          }}
        >
          {icon}
        </Box>

        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography sx={{ fontWeight: 950, fontSize: 22, lineHeight: 1.1 }}>
            {value}
          </Typography>

          <Typography
            sx={{ color: "text.secondary", fontWeight: 800, fontSize: 12 }}
          >
            {label}
          </Typography>

          {hint ? (
            <Typography sx={{ color: "text.secondary", fontSize: 12, mt: 0.4 }}>
              {hint}
            </Typography>
          ) : null}
        </Box>
      </Stack>
    </Paper>
  );
}
